module.exports = __webpack_public_path__ + "static/media/logo.d2e4fa0a.png";